import { render, staticRenderFns } from "./cell-tags.vue?vue&type=template&id=2e82b9c9&"
import script from "./cell-tags.vue?vue&type=script&lang=js&"
export * from "./cell-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports